import { Mail } from "lucide-react";

import { Button } from "@/components/ui/button";
import IconTile from "@/components/ui/icon-tile";
import { STUDIO_SUPPORT_EMAIL } from "@/lib/workspaces/suspension";

/**
 * The frame every notice that replaces the whole app shares: a studio that is
 * suspended (`StudioSuspendedNotice`) and a browser with JavaScript off
 * (`NoScriptNotice`). One card on the page background, a coral icon tile, a
 * title and the body each notice supplies. Rendered by the root layout with no
 * page chrome around it, so it must stand on its own, and it must render
 * without JavaScript: nothing here is a client component.
 */
export default function FullScreenNotice({ icon, title, children }) {
  return (
    <main className="flex flex-1 items-center justify-center bg-gray-50 px-6 py-12">
      <div className="w-full max-w-lg rounded-2xl border border-gray-200 bg-white p-8 sm:p-10">
        <IconTile icon={icon} size="lg" tone="brand" />
        <h1 className="mt-6 text-2xl font-semibold text-gray-900">{title}</h1>
        {children}
      </div>
    </main>
  );
}

/**
 * The one action both notices offer: email Salesably, with the subject already
 * filled in. A plain link styled as the primary button, so it works with no
 * JavaScript and reads the same on both notices.
 */
export function EmailSupportLink({ subject, email = STUDIO_SUPPORT_EMAIL }) {
  const href = `mailto:${email}?subject=${encodeURIComponent(subject)}`;
  return (
    <div className="mt-6">
      <Button asChild className="gap-2 rounded-full">
        <a href={href}>
          <Mail className="h-4 w-4" aria-hidden />
          Email {email}
        </a>
      </Button>
    </div>
  );
}
